import { ErrorAction, ErrorMutation } from "../types";

export default {
  [ErrorAction.dialogControls]({ commit }: any, data: any) {
    commit(ErrorMutation.SET_DIALOG_CONTROLS, data);
  },
};
